import { render } from "./EditManagerPermission.vue?vue&type=template&id=60e1f4ac&scoped=true"
import script from "./EditManagerPermission.vue?vue&type=script&lang=js"
export * from "./EditManagerPermission.vue?vue&type=script&lang=js"

import "./EditManagerPermission.vue?vue&type=style&index=0&id=60e1f4ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e1f4ac"]])

export default __exports__